import { Injectable } from '@angular/core';
import { ConfigService } from '../config.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { MessageServiceEnum, TextMessage } from './commonInterfaces';
import { switchMap } from 'rxjs';
import { DataTransform, DateField } from './dataTransformFunctions';

export interface GetTextMessagesResponse extends TextMessage {
  recipientCount: number,
  unsubscribeCount: number
}

@Injectable({
  providedIn: 'root'
})
export class TextMessageService {

  constructor(
    private config: ConfigService,
    private http: HttpClient
  ) { }

  readonly textMessageDateFields: DateField<TextMessage>[] = [
    {dateType: "utc", fieldName: "sendDate"}
  ]



  getTextMessages(filters: {messageService?: MessageServiceEnum}) {
    
    let params = new HttpParams()

    if (filters.messageService) {
      params = params.append("messageService", filters.messageService)
    }

    return this.http.get<GetTextMessagesResponse[]>(`${this.config.dataApiUrl}/text-messaging/messages`, {params: params}).pipe(
      switchMap(result => {
        return DataTransform.replaceDatesArray(result, this.textMessageDateFields )
      })
    )

  }

}
